
import Vue from 'vue';
import Plyr, { PlyrEvent, StandardEvent } from 'plyr';
import { PlayerComponent } from './VideoPlayer';
import { VideoType } from './VideoPlayer.enums';
import { PLYR_CONTROLS, PLYR_EVENTS } from './VideoPlayer.config';
import PlayerIcons from '!!raw-loader!plyr/dist/plyr.svg';

/**
 * `VideoPlayer Player` - contains the player itself, the controls and captions for the video using Plyr library
 */
export default (Vue as PlayerComponent).extend({
  name: 'owc-player',
  props: {
    playerData: {
      type: Object,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    hasUserInteracted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      player: null,
    };
  },
  watch: {
    hasUserInteracted(isUserInteracted) {
      if (isUserInteracted) {
        this.initializePlyr();
      }
    },
  },
  computed: {
    source() {
      return this.playerData?.source;
    },
    internal() {
      return this.playerData?.videoDetails?.type === VideoType.internal;
    },
    subtitlesSource() {
      return this.playerData?.subtitlesSource;
    },
    plyrSvg: function() {
      return PlayerIcons;
    },
    posterImage: function() {
      // forced meanwhile, since cmm-privacy-shield can only handle one image
      return this.playerData.thumbnail?.source?.replace('{mq}', 'mq2');
    },
  },
  mounted() {
    if (!this.internal && this.$refs.shield) {
      (this.$refs.shield as Element).addEventListener('privacyShieldVideoPlay', (ev: any) => {
        this.$emit('trackEvent', { type: 'privacy-shield-video-play', detail: { videoTitle: ev.detail } });
      });
      (this.$refs.shield as Element).addEventListener('privacyShieldVideoPercentagePlayed', (ev: any) => {
        this.$emit('trackEvent', { type: 'privacy-shield-video-percentage-played', detail: ev.detail });
      });
    }
  },
  methods: {
    initializePlyr() {
      // Unfortunately watching the `source` and initialize the playser as soon
      // as the source is set won't work. This will cause the other implementation
      // to malfunction.
      this.$nextTick(() => {
        this.player = new Plyr(this.$refs.player, {
          controls: [
            PLYR_CONTROLS.play,
            PLYR_CONTROLS.progress,
            PLYR_CONTROLS.volume,
            PLYR_CONTROLS.fullscreen,
            PLYR_CONTROLS.captions,
            PLYR_CONTROLS.playLarge,
          ],
          ...this.playerData?.videoPlayerSettings,
        });

        this.player.on(PLYR_EVENTS.ready as StandardEvent, (event: PlyrEvent) => {
          this.$emit('onReady', event.detail.plyr);
        });
      });
    },
  },
});
